export default __webpack_public_path__ + "static/media/highq.6a39e3f8.jpg";